export default __webpack_public_path__ + "static/media/employee3.d94e68d2.png";